import { type DashboardPeriod } from '@cpg/common';

import { authRequest } from './client';
import {
  type DashboardHealthResponse,
  type FinanceDashboardResponse,
  type MerchantsDashboardResponse,
  type PaymentsDashboardResponse,
} from './types';

// ─── backoffice-api dashboard client ───────────────────────────────────────
//
// Thin fetch wrappers around backoffice-api's four `GET /v1/dashboard/*`
// tile endpoints (Task 16). `payments`/`finance`/`merchants` each take a
// required `period` query param; `health` takes none — every one of its
// tiles is a current snapshot, not a period-bounded aggregate. Each is
// independently role-gated server-side; the `_app.dashboard.tsx` page skips
// calling a given function entirely (via TanStack Query's `enabled`) when
// the signed-in admin lacks the role for that block.

export function getPaymentsDashboard(period: DashboardPeriod): Promise<PaymentsDashboardResponse> {
  return authRequest<PaymentsDashboardResponse>(`/dashboard/payments?period=${period}`);
}

export function getFinanceDashboard(period: DashboardPeriod): Promise<FinanceDashboardResponse> {
  return authRequest<FinanceDashboardResponse>(`/dashboard/finance?period=${period}`);
}

export function getHealthDashboard(): Promise<DashboardHealthResponse> {
  return authRequest<DashboardHealthResponse>('/dashboard/health');
}

export function getMerchantsDashboard(period: DashboardPeriod): Promise<MerchantsDashboardResponse> {
  return authRequest<MerchantsDashboardResponse>(`/dashboard/merchants?period=${period}`);
}
